import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Grid 
} from '@mui/material';
import styled from '@emotion/styled';

// Styled components
const AboutSection = styled(Box)(({ theme }) => ({
  padding: '110px 0',
  position: 'relative',
  overflow: 'hidden',
  backgroundImage: 'url("/assets/images/bg/about-bg.png")',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  width: '100vw',
  marginLeft: 'calc(-50vw + 50%)',
  [theme.breakpoints.down('md')]: {
    padding: '70px 0 65px',
    width: '100%',
    marginLeft: 0,
  },
}));

const GeometricPattern = styled(Box)({
  position: 'absolute',
  zIndex: 0,
  '&.top-left': {
    top: 0,
    left: 0,
  },
  '&.bottom-right': {
    bottom: 0,
    right: 0,
  },
  '&.left-middle': {
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  '&.right-middle': {
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
});

const ImagesPart = styled(Box)({
  position: 'relative',
  '& img': {
    width: '100%',
    borderRadius: '5px',
  },
});

const ContentPart = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingLeft: '60px',
  },
  [theme.breakpoints.down('md')]: {
    paddingLeft: '15px',
    marginTop: '50px',
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '36px',
  fontWeight: 700,
  lineHeight: 1.3,
  marginBottom: '30px',
  paddingTop: '30px',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    display: 'block',
    width: '70px',
    height: '4px',
    backgroundColor: '#bb0b0b',
  }
}));

const SubText = styled(Typography)({
  fontSize: '18px',
  lineHeight: 1.7,
  marginBottom: '20px',
  color: '#333',
  fontWeight: 500,
});

const Description = styled(Typography)({
  fontSize: '16px',
  lineHeight: 1.7,
  color: '#555',
  marginTop: '0',
});

const DiscoverButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#bb0b0b',
  color: '#ffffff',
  padding: '12px 30px',
  borderRadius: '0',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'uppercase',
  marginTop: '45px',
  '&:hover': {
    backgroundColor: '#d30b0d',
  }
}));

function About() {
  return (
    <AboutSection id="rs-about">

      <Container maxWidth="lg">
        <Grid container alignItems="center">
          <Grid item xs={12} md={6}>
            <ImagesPart>
              <img src="/assets/images/about/about.png" alt="About HKMSP" />
            </ImagesPart>
          </Grid>
          <Grid item xs={12} md={6}>
            <ContentPart>
              <Title variant="h2">
                Secure Your Digital Frontier
              </Title>
              <SubText>
                With Over 20 Years Of Dedicated Experience In Cybersecurity And IT Infrastructure Management, We Lead The Charge In Safeguarding Your Digital Assets
              </SubText>
              <Description variant="body1">
                We partner with industry leaders and emerging disruptors alike, ensuring that your operations are fortified against the ever-evolving cyber threats. From securing end-to-end IT environments to deploying cutting-edge defense mechanisms, our team is committed to your peace of mind
              </Description>
              <Box className="btn-part mt-45">
                <DiscoverButton href="#rs-about" className="readon consultant discover">
                  Discover More
                </DiscoverButton>
              </Box>
            </ContentPart>
          </Grid>
        </Grid>
      </Container>
    </AboutSection>
  );
}

export default About;
